<template>
  <div>
    <el-form :inline="true" :model="queryForm" size="small">
      <el-form-item label="选择楼栋">
        <el-cascader v-model="houseArr_queryForm" :options="houseCascaderData" :props="cascaderProps" clearable
          @change="handleCascaderChange_queryForm" class="el-input_inner--rewrite"></el-cascader>
      </el-form-item>
      <el-form-item>
        <el-button @click="handleSearch" type="primary">查询</el-button>
        <el-button @click="handleAdd" type="primary">新增</el-button>
      </el-form-item>
    </el-form>

    <el-table :data="tableData" v-loading="tableLoading" border stripe
      :header-cell-style="{background:'#E4E7ED',color: '#606266'}" size="small" style="width: 100%;" max-height="500px">
      <el-table-column label="#" type="index"></el-table-column>
      <el-table-column label="楼层名称" v-slot="{ row }">
        {{ `${row.building.area.name} / ${row.building.name} / ${row.name}` }}
      </el-table-column>
      <el-table-column label="是否启用" v-slot="{ row }">
        <el-tag v-if="row.status === 1" type="success" size="small">启用</el-tag>
        <el-tag v-else type="info" size="small">禁用</el-tag>
      </el-table-column>
      <el-table-column label="操作">
        <template v-slot="{ row }">
          <el-link @click="handleEdit(row)" type="primary" class="margin-r-10">编辑</el-link>
          <el-popconfirm @confirm="handleDel(row.id)" title="确定删除吗？">
            <el-link slot="reference" type="danger">删除</el-link>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <div class="margin-t-10 flex">
      <el-pagination background layout="prev, pager, next, total, jumper" :total="total"
        :current-page.sync="queryForm.page" :page-size="pageSize" @current-change="getFloorData">
      </el-pagination>
      <el-button size="small">确定</el-button>
    </div>

    <!-- 新增、编辑弹窗 -->
    <el-dialog :title="dialogTitle" :visible.sync="showDialog" :close-on-click-modal="false" @close="closeDialog"
      width="500px">
      <el-form ref="form" :model="form" :rules="rules" label-width="80px">
        <el-form-item label="楼层名称" prop="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="选择楼栋" prop="houseArr">
          <el-cascader v-model="form.houseArr" :options="houseCascaderData" :props="cascaderProps" clearable
            class="el-input_inner--rewrite"></el-cascader>
        </el-form-item>
        <el-form-item label="是否启用">
          <el-switch v-model="form.status" :active-value="1" :inactive-value="0" active-color="#13ce66"
            inactive-color="#ff4949" active-text="启用" inactive-text="禁用">
          </el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="closeDialog">取消</el-button>
        <el-button @click="handleSubmit" :loading="formSubmitting" type="primary">提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import {
    saveFloorAPI,
    delFloorAPI,
    getFloorDataAPI,
    getHouseCascaderDataAPI,
  } from '@/api/base-data.js'

  export default {
    name: 'Floor',
    data() {
      return {
        houseCascaderData: [],
        cascaderProps: {
          label: 'name',
          value: 'id'
        },

        // 查询相关
        houseArr_queryForm: [],
        queryForm: {
          page: 1,
          home_building_id: '',
        },

        // 表格相关
        tableData: [],
        total: 0,
        pageSize: 0,
        tableLoading: false,
        curRowData: null,

        // 表单相关
        showDialog: false,
        dialogTitle: '',
        formSubmitting: false,
        form: {
          name: '',
          houseArr: [],
          status: 1
        },
        rules: {
          name: [{
            required: true,
            message: '楼层名称不能为空',
            trigger: 'blur'
          }],
          houseArr: [{
            required: true,
            message: '楼栋不能为空',
            trigger: 'change'
          }],
        }
      }
    },
    created() {
      this.getFloorData()
      this.getHouseCascaderData()
    },
    methods: {
      // 新增按钮
      handleAdd() {
        this.showDialog = true
        this.dialogTitle = '新增'
      },
      // 查询按钮
      handleSearch() {
        this.queryForm.page = 1
        this.getFloorData()
      },
      // 搜索表单的级联改变 --设置 queryForm.home_building_id
      handleCascaderChange_queryForm(e) {
        if (e.length > 1) this.queryForm.home_building_id = e[e.length - 1]
        else this.queryForm.home_building_id = ''
      },
      closeDialog() {
        this.$refs.form.resetFields()
        this.showDialog = false
      },
      // 编辑按钮
      handleEdit(row) {
        this.showDialog = true
        this.dialogTitle = '编辑'
        this.curRowData = JSON.parse(JSON.stringify(row))
        // 设置form
        for (let key in this.form) {
          this.form[key] = this.curRowData[key]
        }
        // 回显楼栋
        this.form.houseArr = [this.curRowData.home_area_id, this.curRowData.home_building_id]
      },
      // 删除按钮
      handleDel(id) {
        delFloorAPI({
          id,
        }).then(res => {
          if (res.code === 0) {
            this.$message.success(res.msg)
            this.getFloorData()
          }
        })
      },
      // 提交按钮
      handleSubmit() {
        this.$refs.form.validate(isValid => {
          if (!isValid) return
          if (this.form.houseArr.length < 2) return this.$message.error('未选择到楼栋，请检查')

          this.formSubmitting = true
          const data = {
            name: this.form.name,
            home_area_id: this.form.houseArr[0],
            home_building_id: this.form.houseArr[1],
            status: this.form.status
          }
          if (this.dialogTitle === '编辑') data.id = this.curRowData.id
          // 提交
          saveFloorAPI(data).then(res => {
            this.$message.success(res.msg)
            this.closeDialog()
            this.getFloorData()
          }).finally(() => this.formSubmitting = false)
        })
      },
      // 获取楼层数据
      getFloorData() {
        this.tableLoading = true

        getFloorDataAPI(this.queryForm).then(res => {
          this.tableData = res.data
          this.total = res.total
          this.pageSize = res.per_page
          this.tableLoading = false
        })
      },
      // 获取级联数据（获取到楼栋）
      getHouseCascaderData() {
        getHouseCascaderDataAPI({
          level: 1
        }).then(res => {
          this.houseCascaderData = res.data
        })
      }
    }
  }
</script>

<style scoped>
</style>